import { useActiveUserSetLeads } from './useActiveUserSetLeads';

// active user changes the user has not opened from the bell yet
export const useUnprocessedActiveUserSetLeads = () => {
    const { data: leads } = useActiveUserSetLeads();
    return (leads ?? []).filter((lead) => !lead.isProcessed);
};
